export * from './fields/ProductUserNeed.fields';
export * from './fields/ProductDesignInput.fields';
export * from './fields/ProductDesignOutput.fields';
export * from './fields/ProductVerification.fields';
export * from './fields/ProductValidation.fields';
export * from './fields/ProductDesignSpec.fields';

export const ProductFieldLabels = {
  name: 'Name',
  description: 'Description',
  identifier: 'Identifier',
  regionsMarketed: 'Regions Marketed',
  intendedUse: 'Intended Use',
  productOwner: 'Product Owner',
  techLead: 'Tech Lead',
  components: 'Components',
  releases: 'Releases',
  attachment: 'Attachments',
  taskFiles: 'Document References'
} as const;

export type ProductField = keyof typeof ProductFieldLabels;

export const ProductFields: ProductField[] = Object.keys(
  ProductFieldLabels
) as ProductField[];
